<template>
  <div class="list-content">
    <div class="top-selector">
      <selector class="selector-item" :options="servers" :name="T('Server')" hasNullSelect v-model="serverId"></selector>
      <selector class="selector-item" :options="kingdoms" :name="T('Kingdom')" hasNullSelect v-model="kingdomId"></selector>
      <selector class="selector-item" :options="langeuages" :name="T('Language')" hasNullSelect v-model="langeuage"></selector>
      <div class="search">
        <input v-model="keyWords" :placeholder="T('Search')" @keyup.enter="search"/>
        <span class="search-icon" @click="search"></span>
      </div>
    </div>
    <div class="th">
      <span class="colume-1"><span>{{ T('Alliance_Flag') }}</span></span>
      <span class="colume-2"><span>{{ T('Alliance_Name') }}</span></span>
      <span class="colume-3"><span>{{ T('Server') }}</span></span>
      <span class="colume-4"><span>{{ T('Power') }}</span></span>
      <span class="colume-5"><span>{{ T('Language') }}</span></span>
    </div>
    <div ref="table" class="table">
      <div v-if="listArr.length" class="table-wrapper">
        <div class="t-row" v-for="(item, index) in listArr" :key="index" @click="toDetail(item.legion_id)">
          <span class="colume-1">
            <flag width="50" :flagStyle="{bg: item.bg_id, edgings: item.edgings_id, pattern: item.pattern_id}"></flag>
          </span>
          <span class="colume-2"><span><i :class="{green: item.county.toUpperCase() == 'SHU', red: item.county.toUpperCase() == 'WUU', blue: item.county.toUpperCase() == 'WEI'}">[{{ item.legion_nick_name }}]</i>{{ item.legion_name }}</span></span>
          <span class="colume-3"><span>{{ item.world_name }}</span></span>
          <span class="colume-4"><span>{{ item.power | thousandBitSeparator }}</span></span>
          <span class="colume-5"><span>{{ item.language_id | transformLang }}</span></span>
        </div>
        <span class="load-content" ref="tableLoad">{{ isMaxPage ? T('No_information') : '' }}</span>
      </div>
      <div v-else-if="hasLoadList" class="isEmpty">
        {{ T('No_information') }}
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from 'better-scroll'
import selector from '@/components/Selector'
import flag from '@/components/UnionFlag'
import { recommendList, newList } from '@/common/api'
import { mapState } from 'vuex'
import { debounce } from '@js/utils'
// 列表
export default {
    data() {
        return {
          hasLoadList: false,
          listType: 1, // 1 推荐  2 最新
          kingdoms: [
            {
              key: 'WEI',
              value: 'Ydvia'
            },
            {
              key: 'SHU',
              value: 'Vitas'
            },
            {
              key: 'WUU',
              value: 'Ruslan'
            }
          ],
          langeuages: [],
          serverId: 'none', // 筛选服务器
          kingdomId: 'none', // 筛选阵营
          langeuage: 'none', // 筛选语言
          keyWords: '', // 搜素文字
          searchWord: '', // 实际搜索文字
          listArr: [], // 列表容器
          reloadListWithRoute: true, // 是否根据路由变化刷新列表

          bs: null, // better-scroll对象

          fetchMaxRow: 0,
          pageIndex: 0, // 当前页
          isMaxPage: false, // 到达最大页码
        }
    },
    computed: {
      ...mapState({
        servers: 'servers'
      })
    },
    components: {
      selector,
      flag
    },
    watch: {
      kingdomId(newVal) {
        console.log('kingDom:', newVal)
        this.setRouter()
      },
      serverId(newVal) {
        console.log('serverId:', newVal)
        this.setRouter()
      },
      langeuage(newVal) {
        console.log('langeuage:', newVal)
        this.setRouter()
      },
      searchWord(newVal) {
        console.log('searchWord:', newVal)
        this.setRouter()
      },
      $route: {
        handler(newVal) {
          this.$nextTick(() => {
            if (!this.reloadListWithRoute || !newVal.path.includes('list')) {
              this.reloadListWithRoute = true
              return
            }
            this.resetList()
            this.init()
          })
        },
        immediate: true
      }
    },
    beforeRouteEnter(to, from, next) {
      let f = 'f' in to.query ? decodeURIComponent(to.query.f) : false
      if (f) {
        f = JSON.parse(window.atob(f))
        if (from.path.includes('detail')) {
          // 如果是从详情页过来的并且页面参数和之前一致则不更新列表
          next((vm) => {
            console.log(f.t, vm.listType)
            if (vm.listArr.length && f.t == vm.listType) {
              vm.reloadListWithRoute = false
            }
          })
        } else {
          next()
        }
      } else {
        next()
      }
    },
    methods: {
      async init() {
        this.langeuages = Object.keys(this.langObj).map(i => {
          return {
            value: this.langObj[i],
            key: i
          }
        })
        await Promise.all([this.fetchServer()])
        let filters = this.$route.query.f && decodeURIComponent(this.$route.query.f)
        if (filters) {
          filters = JSON.parse(window.atob(filters))
          console.log(filters)
          this.$nextTick(() => {
            this.listType = filters.t || 1
            this.kingdomId = filters.k || 'none'
            this.langeuage = filters.l || 'none'
            this.keyWords = this.searchWord = filters.w ? String.fromCharCode.apply(null, filters.w.split(',')) : '' || ''
            this.serverId = filters.s || 'none'
            this.fetchList()
          })
        } else {
          this.fetchList()
        }
      },
      async fetchServer() {
        await this.$store.dispatch('upDateServers')
      },
      async fetchList() {
        if (this.hasLoadList) {
          this.$Spinner.showLoading(this.$refs.tableLoad, false)
        } else {
          this.$Spinner.showLoading(this.$refs.table)
        }
        let api = this.listType == 1 ? recommendList : newList
        let data = await api({
          page: ~~this.pageIndex,
          world_id: this.serverId == 'none' ? '' : this.serverId,
          county: this.kingdomId == 'none' ? '' : this.kingdomId,
          language_id: this.langeuage == 'none' ? '' : this.langeuage,
          name: this.searchWord
        })
        
        if (data.status == 200) {
          if (data.data.list.length) {
            if (this.hasLoadList) {
              if (data.data.list.length < this.fetchMaxRow) {
                // 如果已经获取过列表 则判断是否最大页码
                this.isMaxPage = true
              } else {
                this.isMaxPage = false
              }
            } else {
              this.fetchMaxRow = data.data.list.length
            }
            this.listArr = this.listArr.concat(data.data.list)
            if (!this.bs) {
              this.$nextTick(() => {
                this.bs = new BScroll(this.$refs.table, {
                  click: true,
                  mouseWheel: true,
                  scrollY: true,
                  observeDOM: true,
                  probeType: 3,
                  swipeTime: 1000,
                  preventDefault: true,
                  bounce: true,
                  bounceTime: 500,
                  pullUpLoad: {
                    threshold: 100
                  },
                })
                this.bs.on('pullingUp', () => {
                  if (!this.isMaxPage) {
                    this.pageIndex++
                    this.fetchList()
                  }
                })
              })
            }
            this.$nextTick(() => {
              this.bs.finishPullUp()
              this.bs.refresh()
            })
          } else {
            this.isMaxPage = true
          }
        }
        if (this.hasLoadList) {
            this.$Spinner.hideLoading(this.$refs.tableLoad)
        } else {
          this.$Spinner.hideLoading(this.$refs.table)
        }
        this.hasLoadList = true
      },
      resetList() {
        this.fetchMaxRow = 0
        this.hasLoadList = false
        this.listArr = []
        this.pageIndex = 0 // 重置页码
        this.isMaxPage = false // 重置总页数
      },
      setRouter: debounce.call(this, function() {
        this.$router.push({
          path: '/',
          query: {
            f: window.btoa(JSON.stringify({
              t: this.listType,
              s: this.serverId,
              k: this.kingdomId,
              l: this.langeuage,
              w: this.keyWords.split('').reduce(function(res, i) {
                res.push(i.charCodeAt())
                return res
              }, []).join(',')
            }))
          }
        })
      }, 50),
      search() {
        this.searchWord = this.keyWords
      },
      toDetail(id) {
        this.$router.push({
          path: `/detail/${id}`
        })
      }
    }
}
</script>

<style lang="scss" scoped>
.list-content {
  @include bgImg('di2.png');
  width: 100%;
  height: 100%;
  padding: .25rem;
  display: flex;
  flex-direction: column;

  .top-selector {
    display: flex;
    align-items: center;
    margin-bottom: .15rem;

    .selector-item {
      width: 23%;
      margin-right: .15rem;
      border-radius: .05rem;
      box-shadow: 0 2px 0 0 #71a0cc;
    }

    .search {
      display: flex;
      flex: 1;
      padding: .01rem;
      align-items: center;
      height: .5rem;
      background-color: #5a88c4;
      box-shadow: 0 2px 0 0 #71a0cc;
      border: solid .02rem #436c9b;

      input {
        flex: 1;
        width: 100%;
        height: 100%;
        padding-left: .15rem;
        color: #d0e3f4;
        background-color: rgba(0,0,0,0);
        border: none;
      }

      .search-icon {
        @include bgImg('icon-search.png');
        width: .5rem;
        height: 100%;
        background-size: .22rem;
        cursor: pointer;
      }
    }
  }

  .th {
    margin: .1rem 0;
    font-size: .2rem
  }

  .t-row {
    height: .8rem;
    background: #4979b6;
    margin-bottom: .15rem;
    overflow: hidden;
    cursor: pointer;
  }

  .th, .t-row {
    display: flex;
    align-items: center;

    &>span {
      @include ellipsis();
      text-align: center;
      span {
        display: block;
        transform: scale(.75);
      }
    }
    
    .colume-1 {
      position: relative;
      width: 1.27rem;
      height: 100%;
    }
    .colume-2 {
      flex: auto;
      width: 2.65rem;

      i {
        font-style: normal;
        margin-right: .1rem;
      }
    }
    .colume-3 {
      width: 2.37rem;
    }
    .colume-4 {
      width: 1.35rem;
    }
    .colume-5 {
      width: 1.86rem;
    }
  }

  .table {
    position: relative;
    height: 100%;
    overflow: hidden;
  }

  .table-wrapper {
    position: relative;
  }

  .load-content {
    position: relative;
    left: 0;
    right: 0;
    display: block;
    height: 1rem;
    transform: scale(.5);
    transform-origin: center top;
    text-align: center;
    font-size: .6rem;
  }

  .isEmpty {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100% - 1rem);
  }
}
</style>